var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orientationSvg)?_c('tooltip',{attrs:{"tooltip-wrapper-class-name":"tool-tip__wrapper--relative tool-tip__wrapper--orientation","content":_vm.orientationText,"hover":""}},[_c('div',{staticClass:"orientation tool-tip__arrow-hook",domProps:{"innerHTML":_vm._s(_vm.orientationSvg)}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12fe218e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/orientation.vue
// module id = null
// module chunks = 